import { Table as AntTable, TableProps, TablePaginationConfig } from "antd";
import classnames from "classnames";

import styles from "./Table.module.scss";

interface Props<T> extends TableProps<T> {}
type TablePagination = false | TablePaginationConfig;

const PAGE_SIZE_DEFAULT = 10;

export function Table<T extends object>({
  className,
  pagination: paginationProp,
  ...restProps
}: Props<T>) {
  const classNames = classnames(styles.table, className);
  const pageSize =
    paginationProp instanceof Object && paginationProp?.pageSize
      ? paginationProp?.pageSize
      : PAGE_SIZE_DEFAULT;

  const pagination: TablePagination =
    (restProps.dataSource?.length || 0) > pageSize
      ? {
          pageSize: PAGE_SIZE_DEFAULT,
          simple: true,
          position: ["bottomCenter"],
          ...paginationProp,
        }
      : false;

  return (
    <AntTable {...restProps} className={classNames} pagination={pagination} />
  );
}
